import React from 'react';
import { useTranslation } from 'react-i18next';
import { pickField } from '@/temu-platform/utils/temuResponse';
import TemuProductThumb from '@/temu-platform/modules/products/components/TemuProductThumb';
import HoverCopyField from '@/temu-platform/modules/products/components/HoverCopyField';
import { normalizeImageUrl } from '@/temu-platform/modules/aftersales/returnOrderDisplay';

export function extractGoodsList(row) {
  if (Array.isArray(row?.goodsList) && row.goodsList.length) return row.goodsList;
  if (Array.isArray(row?.itemList) && row.itemList.length) return row.itemList;
  return [];
}

/**
 * 产品信息单元格（样式对齐订单列表：标题悬浮复制 + SKC / 商家SKU）。
 * @param {number|null} maxVisible 列表默认只展示 1 件；传 null 展示全部（详情等场景）
 */
export default function FinanceListGoodsCell({ goods, maxVisible = 1 }) {
  const { t } = useTranslation('workbench');
  const list = Array.isArray(goods) ? goods : [];
  if (!list.length) {
    return <span className="tpo-return-product__empty">{t('finance.noGoods')}</span>;
  }
  const limit = maxVisible == null || maxVisible <= 0 ? list.length : maxVisible;
  const visible = list.slice(0, limit);
  return (
    <div className="tpo-finance-list-goods">
      <div className="tpo-finance-list-goods__grid">
        {visible.map((item, idx) => {
          const title = pickField(item, 'goodsTitle', 'productName', 'spuName', 'title') || '';
          const merchantSku = pickField(item, 'supplierSku', 'sellerSku', 'merchantSku', 'supplier_sku') || '';
          const skc = pickField(item, 'skcName', 'skcCode', 'skc', 'platformSkcId') || '';
          const supplierCode = pickField(item, 'supplierCode', 'goodsSn', 'articleNo') || '';
          const img = normalizeImageUrl(pickField(item, 'imageUrl', 'mainImageUrl'));
          const key = `${skc || merchantSku || title || 'g'}-${idx}`;
          if (!title && !img && !skc && !merchantSku && !supplierCode) {
            return (
              <span key={key} className="tpo-return-product__empty">{t('finance.noGoods')}</span>
            );
          }
          return (
            <div key={key} className="tpo-return-product">
              {img ? (
                <TemuProductThumb
                  imageUrl={img}
                  className="tpo-return-product__img"
                  placeholderClassName="tpo-return-product__img tpo-return-product__img--empty"
                  alt={title || merchantSku || t('finance.goodsAlt')}
                />
              ) : (
                <div className="tpo-return-product__img tpo-return-product__img--empty" />
              )}
              <div className="tpo-return-product__meta">
                <HoverCopyField
                  value={title}
                  className="tpo-return-product__title"
                  popoverCopy
                />
                <HoverCopyField
                  label="SKC"
                  value={skc}
                  className="tpo-return-product__sku"
                />
                <HoverCopyField
                  label={t('certList.merchantSku')}
                  value={merchantSku}
                  className="tpo-return-product__sku"
                />
                {supplierCode ? (
                  <HoverCopyField
                    label={t('tiktokCatalog.supplier')}
                    value={supplierCode}
                    className="tpo-return-product__sku"
                  />
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
